import React, { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function DeactiveClubModal({ club,cancelModal }) {
  const [input, setInput] = useState("");
  const [inputErr, setInputErr] = useState("");
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navi = useNavigate();
  const {user} = useAuthContext();
  //styled
const handleExit = () => {
    cancelModal();
    navi("/")
}

  const handleDeactivate = async () =>{
    setIsLoading(true);
    setInputErr(""); // Reset input error state
    let err = false;

    try {
      if (input !== "Deactivate this club") {
        err = true;
        setInputErr("Invalid input");
      } else {
        const deleteResponse = await axios.delete(
          `${ApiConnectionString}/api/club/${club.id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (deleteResponse.status === 200) {
          setComplete(true)
        } else {
          err = true;
          setInputErr("Failed to deactive club");
        }
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      err = true;
      setInputErr("An error occurred. Please try again.");
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
      if (err) {
        // Optionally, handle any additional error logic here
      }
    }
  };


if (isLoading) {
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <LoadingSpinner />
        <div className="send-modal-footer"></div>
      </div>
    </div>
  );
} else {
  if (complete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Club Deactivated</p></div> 


        <p>The club has been deactivated successfully.</p>


          <div className="send-modal-footer">
            <button className="pointer cancelButton fw-bold mx-2 px-3" onClick={handleExit}>
              Okay
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Deactivate Club</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
         
          <p>
            Enter "Deactivate this club" in the box below and press confirm to
            delete this club.
          </p>
          <div>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            {inputErr && <p className="text-danger">{inputErr}</p>}
          </div>
          <div className="send-modal-footer">
            <button className="delete-button mx-3" onClick={handleDeactivate}>
              Confirm
            </button>
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
          </div>
        </div>
      </div>
    );
  }
}
}